import { lazy, Suspense, type ReactNode } from "react";
import { hasPermission } from "@/lib/api";
import { RouteFallback } from "@/components/public/RouteFallback";
import { AccessRestricted } from "./AccessRestricted";

// The full app shell is only needed when a top-level route is denied. Loading it lazily
// keeps the sidebar and header out of the entry chunk that guest pages download.
const RestrictedShell = lazy(() => import("./RestrictedShell"));

interface PermissionRouteProps {
  anyOf: string[];
  children: ReactNode;
  /** Deny state is AccessRestricted only — the page already sits in a layout shell. */
  nested?: boolean;
}

export function PermissionRoute({ anyOf, children, nested }: PermissionRouteProps) {
  if (anyOf.some(hasPermission)) {
    return <>{children}</>;
  }

  if (nested) {
    return <AccessRestricted missing={anyOf} />;
  }

  return (
    <Suspense fallback={<RouteFallback />}>
      <RestrictedShell missing={anyOf} />
    </Suspense>
  );
}
